import {
  AlertDuration,
  AlertType,
  type ErrorManager,
  PastaError,
  PastaNetworkError,
  PRIORITIES,
  useAlertManager,
} from "@pasta/box-v2";
import { BeforeLeaveNavigationException } from "./errors/navigation.exception";

export const appErrorManagers: ErrorManager[] = [
  {
    errType: PastaNetworkError,
    priority: PRIORITIES.EARLY,
    handler(error, _context) {
      const alertManager = useAlertManager();
      console.error(error);
      if (error instanceof PastaNetworkError) {
        switch (error.statusCode) {
          case 400: //Bad Request
            alertManager.createAlert({
              message:
                "Une erreur est survenue. Message technique: Les données saisies ont été refusées par le serveur.",
              type: AlertType.ERROR,
              duration: AlertDuration.MEDIUM,
            });
            break;
          case 401: //Unauthorized
            alertManager.createAlert({
              message: "Votre authentification est invalide ou expirée.",
              type: AlertType.ERROR,
              duration: AlertDuration.MEDIUM,
            });
            break;
          case 403: //Forbidden
            if (error.body?.redirectUrl) {
              window.location.href = error.body.redirectUrl;
              break;
            }
            alertManager.createAlert({
              message: "Vous n'avez pas les droits suffisants pour accomplir cette action",
              type: AlertType.ERROR,
              duration: AlertDuration.MEDIUM,
            });
            break;
          case 404: //Not Found
            alertManager.createAlert({
              message: "Une erreur est survenue. Message technique: La ressource demandée n'existe pas",
              type: AlertType.ERROR,
              duration: AlertDuration.MEDIUM,
            });
            break;
          case 408: //Request Timeout
            alertManager.createAlert({
              message:
                "La carte à puce n'a pas répondu à temps : vérifiez que le middleware est lancé, que la carte est insérée et saisissez votre code PIN sans attendre, puis réessayez.",
              type: AlertType.ERROR,
              duration: AlertDuration.MEDIUM,
            });
            break;
          case 500: //Internal Server Error
            alertManager.createAlert({
              message: "Une erreur est survenue. Message technique: Une erreur inattendue s'est produite.",
              type: AlertType.ERROR,
              duration: AlertDuration.MEDIUM,
            });
            break;
          case 503: //Service Unavailable
            alertManager.createAlert({
              message: "Le service est momentanément indisponible, veuillez réessayer dans quelques instants.",
              type: AlertType.ERROR,
              duration: AlertDuration.MEDIUM,
            });
            break;
        }
      } else if (error instanceof PastaError) {
        alertManager.createAlert({
          message: error.publicMessage || "Une erreur inconnue est survenue",
          type: error.level === "error" ? AlertType.ERROR : AlertType.WARNING,
          duration: AlertDuration.MEDIUM,
        });
      }
      return true;
    },
  },
  {
    errType: BeforeLeaveNavigationException,
    handler(_err, _context) {
      return true;
    },
  },
];
